import { render, staticRenderFns } from "./registrationFor.vue?vue&type=template&id=1e717597&scoped=true"
import script from "./registrationFor.vue?vue&type=script&lang=js"
export * from "./registrationFor.vue?vue&type=script&lang=js"
import style0 from "./registrationFor.vue?vue&type=style&index=0&id=1e717597&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e717597",
  null
  
)

export default component.exports